import React, {Component, PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, Tooltip, DatePicker, Select, Drawer, notification} from 'antd'
import _ from 'lodash'
import Request, {API_URL} from '../../request'
import {connect} from 'react-redux'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import moment from 'moment'
import { RightsWrapper } from '../../components/_utils/utils'
import ViewResignationDetail from '../../components/_utils/viewResignationDetail'



// class ViewResignationDetail extends Component {
//     state = {
//         record:{}
//     }

//     componentDidMount() {
//         let {record} = this.props
//         this.setState({record})
//         console.log(record)
//     }
    
//     render() {
//         let {record} = this.state
//         return (
            
//         <div style={{textAlign:'center'}}>
//             <div style={{marginTop:'10px'}}>
//             <table style={{width:'80%', textAlign:'center'}}>
//                 <tbody>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Employee Name</th>
//                         <td>{record.userId.name}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>EmployeeId</th>
//                         <td>{record.userId.empId}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Current Address with Pincode</th>
//                         <td>{record.lastWorkingDate && moment(record.lastWorkingDate).format('DD-MMMM-YYYY')}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Manager</th>
//                         <td>{record.manager.name}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>List of Job Responsibilities/Projects</th>
//                         <td>{record.jobResponsibilitiesOrProjects}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Status of Ongoing Projects/Work</th>
//                         <td>{record.statusOngoingProjectsOrWork}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Pending Tasks and Deadlines</th>
//                         <td>{record.pendingTasksAndDeadLines}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Official Email ID</th>
//                         <td>{record.officialEmail}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Official Email ID Password</th>
//                         <td>{record.officalEmailPass}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Official Phone Number</th>
//                         <td>{record.officialPhone}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Official Laptop/Desktop Number</th>
//                         <td>{record.officialLaptopOrDesktop}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Official Laptop/Desktop Password</th>
//                         <td>{record.officialLaptopOrDesktopPass}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Laptop’s Charger</th>
//                         <td>{record.laptopCharger}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Headphones</th>
//                         <td>{record.headphones}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Mouse</th>
//                         <td>{record.mouse}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Any other credentials</th>
//                         <td>{record.anyOtherCredentials}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Please mention here</th>
//                         <td>{record.credentialsSpecify}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Key Contacts and Relationships</th>
//                         <td>{record.keyContactsAndRelationships}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Documentation and Files</th>
//                         <td>{record.documentationAndFiles}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Software and Tools</th>
//                         <td>{record.softwareAndTools}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Backup and Deletion of Email ID</th>
//                         <td>{record.backupAndDeletionEmailId}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Deletion from every official group</th>
//                         <td>{record.deletionOfficialGroup}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Biometric Deactivation</th>
//                         <td>{record.biometricDeactivation}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Any Drawer or Locker Keys</th>
//                         <td>{record.drawerOrLockerKeys}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Identity Card</th>
//                         <td>{record.identityCard}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Any Dues</th>
//                         <td>{record.anyDues}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Due Specification</th>
//                         <td>{record.duesSpecify}</td>
//                     </tr>
//                     <tr style={{textAlign:'center'}}>
//                         <th>Additional Notes</th>
//                         <td>{record.additionalNotes}</td>
//                     </tr>
//                 </tbody>
//             </table>
//             </div>
//         </div>
//         )
//     }
// }


@Form.create()
class ResignationActionForm extends Component {
    state = {
        resignApprove:null,
        resignDisapprove:false,
        
    }

    handleSubmit = (e) =>{
        let {form,dispatch, handleSubmit} = this.props;
        e.preventDefault()
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData);
            handleSubmit(values)
        })
    }

    componentDidMount() {

    }

    render() {
        const {resignApprove,resignDisapprove} = this.state
        const {
            form: {getFieldDecorator}
        } = this.props
        const inputTypes = {
            fields:[
                {
                    label:'Action',
                    key:'status',
                    type:'select',
                    required:true,
                    options:['Approve', 'Disapprove'],
                    onChange:v=>{
                        this.props.form.setFieldsValue({status:v});
                        if(v === "Approve") {
                            this.setState({resignApprove:true, resignDisapprove:false})
                        }else if (v === 'Disapprove') {
                            this.setState({resignDisapprove:true, resignApprove:false})
                        }
                    }
                },
                {
                    label:'Last Working Date',
                    key:'lastWorkingDate',
                    type:'date',
                    hidden:!resignApprove,
                    required:resignApprove,
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                      }
                },
                {
                    label:"Disapprove Reason",
                    key:'disapproveReason',
                    type:'text',
                    hidden:!resignDisapprove,
                    required:resignDisapprove
                }
            ]
        }
        return (
            <Card>
                <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields inputSchema={inputTypes} apiurl={API_URL} getFieldDecorator={getFieldDecorator}  />
                    <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                    </Row>
                </Form>
            </Card>
        )
    }
}



const {MonthPicker} = DatePicker
const Option = Select.Option;
@Form.create()
class StaffResignations extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        defaultPageSize: 20,
        month:moment(),
        activityArr: [],
        oldLeaves:[],
        record:{},
        allUsers:[],
        userId:null,
        showResignationActionForm:false,
        showLeaveAddForm:false,
        detailDrawerVisible:false,
        
    }



    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleStaffLeaveApplication = (record) =>{
        this.setState({showResignationActionForm:true, record:record})
    }

    handleStaffLeaveApplicationClose = () =>{
        this.setState({showLeaveActionForm:false, record:{}})
        this.table.current.reload()
    }

    handleAdd=()=>{
        this.setState({showLeaveAddForm:true})
    }

    handleClose = () =>{
        this.setState({showLeaveAddForm:false})
        this.reload()
    }

    apiRequest = params =>{
        return new Promise(async(resolve)=>{
            params.sortField = "createdByUser.time"
            params.sortOrder = "descend"
            let response = await Request.getStaffResignations(params);
            this.setState({count:response.total})
            resolve(response)
        })
    }

    handleMonthChange = (month,dateString) =>{
        this.setState({month:moment(month)}, ()=>{
            this.reload()
        })
    }

    async componentDidMount() {
        let params = {
            sortField:'_id',
            sortOrder:'ascend',
            results: 200,
            active:true,
            userType:{$ne : "Student"}
        };

        let response = await Request.loadUser({...params, regExFilters: ['name']})
        let userArray = [];
        response.data.map((user, index)=>{
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({allUsers:userArray})
    }

    closeDetailDrawer = () =>{
        this.setState({detailDrawerVisible:false})
    }

    reload = () => {    
        this.table.current.reload();
    };

    render() {
        const {defaultPageSize, showResignationActionForm, detailDrawerVisible, count, record, allUsers, showLeaveAddForm} = this.state
        const columns = [
            {
                title:'Employee Name',
                key:'userId.name',
            },
            {
                title: 'Resignation Reason',
                key: 'resignationReason',
                render:(text,record)=>(
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                )
            },
            {
                title: 'Resignation Date',
                key: 'resignationDate',
                render:(val,record)=>(
                    <div>
                        {record.resignationDate?moment(record.resignationDate).format("DD-MM-YYYY"):null}
                    </div>
                )
            },
            {
                title: 'Last Working Date',
                key: 'lastWorkingDate',
                render:(val,record) =>(
                    <div>
                        {record.lastWorkingDate?moment(record.lastWorkingDate).format("DD-MM-YYYY"):null}
                    </div>
                )
            },
            {
                title:'Created/Updated By',
                key:'updatedByUser.name',
                render:(text,record)=>{
                    if(!record.updatedByUser) {
                        return (
                            <div>{record.createdByUser.name}</div>
                        )
                    }else {
                        return (
                            <div>{record.updatedByUser.name}</div>
                        )
                    }
                }
            },
            {
                title:'Status',
                key:'status'
            },
            {
                title:'Action',
                key:'operation',
                dataindex: "operation",
                render: (text, record) => (
                    <RightsWrapper myRight={'StaffLeaves.edit'}>
                    <React.Fragment>
                    <Tooltip title="Action">
                      <Button
                        size={"small"}
                        shape="circle"
                        onClick={() => this.handleStaffLeaveApplication(record)}
                        icon="forward"
                      />
                    </Tooltip>&nbsp;
                    <Tooltip title="View Details">
                            <Button
                                size={'small'}
                                shape="circle"
                                icon='eye'
                                onClick={() => {
                                    this.setState({
                                        record: record,
                                        detailDrawerVisible: true
                                    })
                                }}
                            ></Button>
                        </Tooltip>
                  </React.Fragment>
                  </RightsWrapper>
                ),
            }
        ]


    return (
        <PageHeaderWrapper title={`Staff Resignations:- ${count}` }>
            {
                detailDrawerVisible?(
                    <ViewResignationDetail onClose={this.closeDetailDrawer} record={this.state.record} />
                ):null
            }
            <Card bordered={true} >
                <TableComp
                    ref={this.table}
                    columns={columns}
                    apiRequest={this.apiRequest}
                    extraProps={{scroll: {x: 1450}}}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
            </Card>
            <Drawer
                 title="Approve/Disapprove Resignation"
                 placement="right"
                 closable={true}
                 onClose={() => {
                    this.setState({
                        showResignationActionForm: false
                    })
                }}
                visible={showResignationActionForm}
                width={600}>
                    <ResignationActionForm loading={this.props.loading} handleSubmit={async values =>{
                        let data = {
                            _id:record._id,
                            userId:record.userId
                        }
                        if(values.status === "Approve") {
                            data.status = "Approved"
                            data.lastWorkingDate = values.lastWorkingDate
                        }else if(values.status === "Disapprove") {
                            data.status = "Disapproved"
                            data.disapproveReason = values.disapproveReason
                        }
                        let response = await Request.updateResignation(data);
                        if(!response.error) {
                            notification.success({
                                message:response.message
                            })
                            this.setState({record:null, showResignationActionForm:false})
                            this.reload()
                        }else {
                            notification.error({
                                message:response.message
                            })
                            this.setState({showResignationActionForm:false})
                        }
                    }} />
                 </Drawer>
                 {/* <Drawer
                    title="Employee Detail"
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            detailDrawerVisible: false
                        })
                    }}
                    visible={detailDrawerVisible}
                    width={600}>
                    <div>
                        <ViewResignationDetail
                            loading={this.props.loading}
                            record={this.state.record}
                        />
                    </div>
                </Drawer> */}
        </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaffResignations)
